const OrderHeader = ({ order }) => {
  return (
    <div className="mb-6 mt-32 lg:mt-24">
      <h1 className="text-2xl lg:text-2xl font-light text-yellowstar animate-neonFlicker">
        Order No. {order?._id?.slice(-3)}
      </h1>
    </div>
  );
};

export default OrderHeader;
